import { INIT } from './app';
import api from './../lib/api';

const CREATE_USER = 'playgrounds/users/create';
const UPDATE_USER = 'playgrounds/users/update';

const reducer = (state = [], action) => {
  let obj;

  switch (action.type) {
    case INIT: {
      const incoming = Array.isArray(action.payload && action.payload.users)
        ? action.payload.users
        : [];
      if (incoming.length > 0) return [...incoming];
      return state.length > 0 ? state : [];
    }
    case CREATE_USER:
      return [...state, action.payload];
    case UPDATE_USER:
      obj = state.find(i => i.id === action.payload.id);
      Object.assign(obj, action.payload);
      return [...state];
    default:
      return state;
  }
};

export const createUser = async ({
  login,
  name,
  lastname,
  role,
  password,
  phone,
  email,
  post,
  sportComplexIds,
}) => {
  const model = api.createUser({
    login,
    role,
    name,
    lastname,
    password,
    phone,
    email,
    post,
    sportComplexIds,
  });

  return {
    type: CREATE_USER,
    payload: model,
  };
};

export const updateUser = async ({
  id,
  login,
  role,
  password,
  phone,
  email,
  name,
  lastname,
  sportComplexIds,
  post,
}) => {
  const model = {
    id,
    login,
    role,
    password,
    phone,
    email,
    name,
    lastname,
    sportComplexIds,
    post,
  };
  const response = await api.updateUser(model);
  if (password !== null && password !== '') {
    await api.changePassword(id, password);
  }
  return {
    type: UPDATE_USER,
    payload: response,
  };
};

export default reducer;
